import { render, staticRenderFns } from "./teacherMissingForm.vue?vue&type=template&id=2f1b1039&"
import script from "./teacherMissingForm.vue?vue&type=script&lang=js&"
export * from "./teacherMissingForm.vue?vue&type=script&lang=js&"
import style0 from "./teacherMissingForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports